<template>
	<!-- <div id="app">
		<img alt="Vue logo" src="./assets/logo.png">
		<HelloWorld msg="Welcome to Your Vue.js App"/>
	</div> -->
<!-- <div id="app">	 -->

 <!-- :style="!isphone? 'min-height:'+(screenHeight-55)+'px;': 'min-height:'+(screenHeight-55)+'px;width:'+screenWidth+'px;'  " -->
	<div id="app" class="home"  :style="!isphone? 'min-height:'+(screenHeight-55)+'px; ' : 'min-height:'+(screenHeight-55)+'px; min-width:'+screenWidth+'px'  ">		 
		
		<Header v-if="header_onshow"  id="Header" @ChangeFunctionBox="ChangeType"  @ChangePanelVisible="ChangePanel" :isPhone="isphone" :islogin="islogin"  :loginInfo="loginInfo" :myCoins="myCoins"  ></Header>
		 
		<el-row style="   background-color: #f6f8fa!important;"    >
			<!-- <el-col :span="3"  style="min-height:1px;">     </el-col> -->
			 <!-- style=" border:1px solid rgb(42, 216, 129); " -->
			<el-col  :span="24"   >
				<div class="mainbox" :style="!isphone? 'min-height:'+(screenHeight-55)+'px;': 'min-height:'+(screenHeight-55)+'px;width:100%'  ">
  
			
					<div class="rightside" > 
						
						<!-- <BreadCrumb :isPhone="isphone"></BreadCrumb> -->
						<!-- <div id='head_tip' class="_tip"> 律师云助理已开启会员模式。欢迎了解体验。  </div> -->
						
						<div class="InnerBox" :style="'min-height:'+screenHeight*0.85+'px;width:100%;overflow:hidden' ">

							<!-- <FunctionList v-if="pageId!='71'" :pageId="pageId" :isPhone="isphone" ></FunctionList> -->

							<!-- <router-div v-else></router-div> -->
							<!-- v-else -->
							<router-view  @ChangeFunctionBox="ChangeType"></router-view>



						</div>	    
		
						<div class="beian" v-if="header_onshow" >
							<a style="text-decoration:none;color:black;" href="https://www.beian.miit.gov.cn/" target="_blank">沪ICP备19022906号 版权所有 上海云踪科技有限公司 </a>
							<!-- <span>技术与法律支持：虞元坚 律师</span> -->
							<span>商务合作: lawtip@qq.com </span>
						</div>
					</div>
 
				</div>



			</el-col>
			<!-- <el-col :span="3"  style="min-height:1px;">   </el-col>  -->

		</el-row>
<!-- v-if="pageId=='home'" -->

		 
		<!-- <OA  v-if="pageId=='oa'" ></OA> -->

 



			<el-dialog
				title="【消息中心】"
				:visible.sync="msgDialogVisible"
				top="10vh"
				>

				<div class='msgCenter'>
					<!-- <div    class="div-parent">
						<div  v-for="(_item ,_index) of  msgList"   v-bind:key="_index"  >
							<div v-if="_index==0" style="width:35px"  class="div-item-title"> {{_item}}</div>
							<div v-if="_index==1" style="width:70px"  class="div-item-title"> {{_item}}</div>
							<div v-if="_index==2" style="width:180px"  class="div-item-title"> {{_item}}</div>
							<div v-if="_index==3" style="width:120px"  class="div-item-title"> {{_item}}</div>
							<div v-if="_index==4" style="width:70px"  class="div-item-title"> {{_item}}</div>

						</div>




					</div> -->


					<div  v-for="(item ,index) of  msgData"   v-bind:key="item._id"   > 

						<div :class='index%2==0? "list_detail":"list_detail2"' style='width:100%;' :data-guest_id='item.guest_id'   :data-ind='index'  :data-nickname="item.nickName"   bindtap='bindtodetail' >
						
							<!-- bindtap='bindtodetail' -->
							<div class="detail_n"   :data-guest_id='item.guest_id'  style="width:35px">{{index+1}}</div>

							<div class="detail_n"     :data-guest_id='item.guest_id'  style="width:70px;position:relative;">
								<!-- <image :src="item.avatarUrl"></image> -->
								<img :src="item.avatarUrl" alt="">
								<!-- <mp-badge  v-if="item[userId].unread>0"  content="{{item[userId].unread>9? '9+':item[userId].unread }}" style="position: absolute;top: -.4em;right: -.3em;"/> -->
							</div>

							<div class="detail_n"     style="width:180px">{{item.nickName}}  </div>
							<!-- <div class="detail_n"  data-name="{{item.name}}"  data-id='{{item._id}}' bindtap='bindtodetail'  >{{item.totaltime}}</div> -->

							<div class="detail_n"  :data-name="item.name"    style="width:120px">
							<pre>{{ item.lasttime }}</pre>
							</div>
							<!-- <div class="detail_n"  data-name="{{item.name}}"    style="width:360px">{{item.lastwork}}</div>   -->
							<div class="detail_n"  :data-name="item.name"  :data-id='item._id' style="width:70px"> 
								<!-- <button :data-_id="item._id"   :data-ind="index"  catchtap="Operate" >操作</button>    -->
								
								<el-button type="info" plain :data-_id="item._id"   :data-ind="index"  style="height:24px;line-height:0px;">操作</el-button>
							</div>  
							
						</div>
					
					</div>  


				</div>

				<!-- <span> 消息中心 </span> -->
				<span slot="footer" class="dialog-footer">
					<el-button @click="msgDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="msgDialogVisible = false">确 定</el-button>
				</span>
			</el-dialog>

 


			<el-dialog
				title="【通知中心】"
				:visible.sync="noticeDialogVisible"
				top="10vh"
				>

				<div class='msgCenter'>
					<div  v-for="(item ,index) of notice_arr "   v-bind:key="index"   > 
						<div  :class="item.isread=='yes'?'noticeRow2':'noticeRow'"  v-html="item.content"   @click="open_notice_detail(item.content,item._id,index)"></div>

						<div style="float:right">{{timestampToTime(item.timestamp/1000)}} </div>

						<!-- <div :class='index%2==0? "list_detail":"list_detail2"' style='width:100%;' :data-guest_id='item.guest_id'   :data-ind='index'  :data-nickname="item.nickName"   bindtap='bindtodetail' >
							<div class="detail_n"   :data-guest_id='item.guest_id'  style="width:35px">{{index+1}}</div>
							<div class="detail_n"     :data-guest_id='item.guest_id'  style="width:70px;position:relative;">
								<img :src="item.avatarUrl" alt="">
							</div>

							<div class="detail_n"     style="width:180px">{{item.nickName}}  </div>
							<div class="detail_n"  :data-name="item.name"    style="width:120px">
							<pre>{{ item.lasttime }}</pre>
							</div>
		
							<div class="detail_n"  :data-name="item.name"  :data-id='item._id' style="width:70px"> 
						
								<el-button type="info" plain :data-_id="item._id"   :data-ind="index"  style="height:24px;line-height:0px;">操作</el-button>
							</div>  
							
						</div> -->
					
					</div>  

					<div style="width:100% "  v-if="$store.state.noticeInfo.num>0">
						<!-- <el-pagination
							style="float:right;width:200px;margin-top:20px;margin-bottom:20px "
							page-size='15'
							small
							layout="prev, pager, next"
							:total="50"
							@change="ChangeNoticePage"
							>
						</el-pagination> -->
	<!-- :current-page.sync="currentPage" -->
						<el-pagination 
							style="float:right;width:200px;margin-top:20px;margin-bottom:20px "
							small
							hide-on-single-page
							@current-change="ChangeNoticePage"
							
							:page-size="15"
							layout="prev, pager, next, jumper"
							:total="$store.state.noticeInfo.num">
						</el-pagination>

					</div>

					<!-- <div  v-for="(item ,index) of  notice"   v-bind:key="index"   > 
						<div class="noticeRow"  v-html="item.notice">

						</div>

	 
					
					</div>   -->


				</div>

				<!-- <span> 消息中心 </span> -->
				<span slot="footer" class="dialog-footer">
					<el-button @click="ReadAllNotice" style="margin-right:20px">全部已读</el-button>

					<el-button @click="noticeDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="noticeDialogVisible = false">确 定</el-button>
				</span>

				<!-- <span slot="footer" class="dialog-footer">
					<el-button @click="msgDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="msgDialogVisible = false">确 定</el-button>
				</span> -->
			</el-dialog>






	</div>
	<!-- </el-container> -->
<!-- </div>	 -->
</template>

<script>
function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}


//++++++++++++++++++++++++++++++++++++++++++

const routes = [
	// '/','/login','/Home','/tools/sound2txt','/tools','/tools/legalfee','/tools/lawyerfee','/tools/daycal','/tools/interest',
	// '/tools/interest2', '/tools/interest3', '/tools/subao','/tools/enforce', '/tools/workinjury', '/tools/traffic',
	// '/tools/numtrans', '/search_tools', '/lawlib','/cause', '/creditloss', '/announce', '/community',
	// '/community/draft/','/community/article',
	// '/wenshu','/crim_sand',
//   { path: '/', redirect:'/tools' ,
	  { path: '/',
	    component: ()=>import('@/components/index.vue') ,
		name:"index" ,
	// children: [
	// 	{
	// 		path: 'sound2txt',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
	// 		name: 'sound2txt',
	// 		component: ()=>import('@/components/toolsbox/sound2txt/sound2txt.vue')   
	// 	}, 
	// //  {path:'/sound2txt', component: ()=>import('@/components/toolsbox/sound2txt/sound2txt.vue'),name:"sound2txt" },
	// ]
 
 
  
 },
 

 

  {
	path:'/tools', 
	component: ()=>import('@/components/toolsbox/cal.vue') ,
	name:"tools" ,
	// children: [
    //     {
    //       path: 'legalfee',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //       name: 'legalfee',
    //       component: ()=>import('@/components/functions/legalfee.vue')   
    //     }, 
 
	// ]
}, 

  {path: '/login', component: ()=>import('@/components/login.vue') , name: 'login'},
//   {path:'/Home',component: ()=>import('@/components/Home.vue' ) ,name:"home" }, //'@/components/Home.vue'

//   {path:'/tools/sound2txt', component: ()=>import('@/components/toolsbox/sound2txt/sound2txt.vue'),name:"sound2txt" },
//   {path:'/tools/legalfee', component: ()=>import('@/components/functions/legalfee.vue') ,name:"legalfee" },
//   {path:'/tools/lawyerfee', component: ()=>import('@/components/functions/lawyerfee.vue') ,name:"lawyerfee" },
//   {path:'/tools/daycal', component: ()=>import('@/components/functions/daycal.vue'), name:"daycal" },
//   {path:'/tools/interest', component: ()=>import('@/components/functions/interest.vue') ,name:"interest" },
 
//   {path:'/tools/interest3', component: ()=>import('@/components/functions/interest3.vue') ,name:"lpr" },
//   {path:'/tools/subao', component: ()=>import('@/components/functions/subao.vue') ,name:"subao" },
//   {path:'/tools/enforce', component: ()=>import('@/components/functions/enforce.vue') ,name:"enforce" },
//   {path:'/tools/workinjury', component: ()=>import('@/components/functions/workinjury.vue') ,name:"workinjury" },
//   {path:'/tools/traffic', component: ()=>import('@/components/functions/traffic.vue') ,name:"traffic" },
//   {path:'/tools/numtrans', component: ()=>import('@/components/functions/numtrans.vue') ,name:"numtrans" },


//   {path:'/sound2txt', component: ()=>import('@/components/toolsbox/sound2txt/sound2txt.vue'),name:"sound2txt" },
//   {path:'/pic2txt', component: ()=>import('@/components/toolsbox/pic2txt.vue'),name:"pic2txt" },
//    {path:'/txtcheck', component: ()=>import('@/components/toolsbox/txtcheck.vue'),name:"txtcheck" },
  {path:'/sound2txt', component: resolve=>(require(["@/components/toolsbox/sound2txt/sound2txt.vue"],resolve)) ,name:"sound2txt" },
 {path:'/txtcheck', name:"txtcheck",  component: resolve=>(require(["@/components/toolsbox/txtcheck2.vue"],resolve)) },
{path:'/pic2txt', component: resolve=>(require(["@/components/toolsbox/pic2txt.vue"],resolve))  ,name:"pic2txt" },
    

  {path:'/legalfee', component: ()=>import('@/components/functions/legalfee.vue') ,name:"legalfee",
	meta:{
		title:'诉讼费计算器',
		show: true,
		content:{
			keywords:"诉讼费,律师工具",

		}
	}
  },
  {path:'/lawyerfee', component: ()=>import('@/components/functions/lawyerfee.vue') ,name:"lawyerfee",
  	meta:{
		title:'律师费计算器',
		show: true,
		content:{
			keywords:"律师费",

		}
	} 
  },

//   {path:'/daycal', component: ()=>import('@/components/functions/daycal.vue'), name:"daycal" },
//   {path:'/interest', component: ()=>import('@/components/functions/interest.vue') ,name:"interest" },
 
//   {path:'/lpr', component: ()=>import('@/components/functions/interest3.vue') ,name:"lpr" },
//   {path:'/subao', component: ()=>import('@/components/functions/subao.vue') ,name:"subao" },
//   {path:'/enforce', component: ()=>import('@/components/functions/enforce.vue') ,name:"enforce" },
//   {path:'/workinjury', component: ()=>import('@/components/functions/workinjury.vue') ,name:"workinjury" },
//   {path:'/traffic', component: ()=>import('@/components/functions/traffic.vue') ,name:"traffic" },
//   {path:'/numtrans', component: ()=>import('@/components/functions/numtrans.vue') ,name:"numtrans" },
//   {path:'/deposit', component: ()=>import('@/components/toolsbox/mine/deposit.vue') ,name:"deposit" },

	{path:'/daycal', component:resolve=>(require(["@/components/functions/daycal.vue"],resolve)), name:"daycal" },
	{path:'/interest', component:resolve=>(require(["@/components/functions/interest.vue"],resolve)),name:"interest" },
	{path:'/interest2', component:resolve=>(require(["@/components/functions/interest2.vue"],resolve)),name:"interest2" },
   {path:'/lpr', component:resolve=>(require(["@/components/functions/interest3.vue"],resolve)),name:"lpr" },

   {path:'/int4', component:resolve=>(require(["@/components/functions/int4.vue"],resolve)),name:"int4" },
	{path:'/int5', component:resolve=>(require(["@/components/functions/int5.vue"],resolve)),name:"int5" },

   {path:'/subao', component:resolve=>(require(["@/components/functions/subao.vue"],resolve)),name:"subao" },
   {path:'/enforce', component:resolve=>(require(["@/components/functions/enforce.vue"],resolve)),name:"enforce" },
   {path:'/workinjury', component:resolve=>(require(["@/components/functions/workinjury.vue"],resolve)),name:"workinjury" },
   {path:'/traffic', component:resolve=>(require(["@/components/functions/traffic.vue"],resolve)),name:"traffic" },
  {path:'/numtrans', component:resolve=>(require(["@/components/functions/numtrans.vue"],resolve)),name:"numtrans" },
  {path:'/deposit', component:resolve=>(require(["@/components/toolsbox/mine/deposit.vue"],resolve)),name:"deposit" },

  {path:'/bevip', component:resolve=>(require(["@/components/toolsbox/mine/bevip.vue"],resolve)),name:"bevip" },
  
//  {path:'/wenshu', component:resolve=>(require(["@/components/functions/wenshu.vue"],resolve)),name:"wenshu" },
 {path:'/wenshu', component:resolve=>(require(["@/components/toolsbox/topics/topics.vue"],resolve)),name:"wenshu" },

 {path:'/topics', component: ()=>import('@/components/toolsbox/topics/topics.vue') ,name:"topics" },


 {path:'/pdf', component: ()=>import('@/components/toolsbox/docs/pdf.vue') , name:'pdf' },
  {path:'/saomiao', component: ()=>import('@/components/toolsbox/docs/saomiao.vue') , name:'saomiao' },

//   {path:'/wenshu_detail', component:resolve=>(require(["@/components/toolsbox/wenshu/wenshu_detail.vue"],resolve)), name:'wenshu_detail' },  

//    {path:'/wenshu/:docid', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'wenshu_detail' },   //article,drafts
  {path:'/lawlib_admin', component:resolve=>(require(["@/components/admin/lawlib_admin.vue"],resolve)), name:'lawlib_admin' },  
 
  {path:'/lawlib', component:resolve=>(require(["@/components/functions/lawlib2.vue"],resolve)), name:'lawlib' },  
//   {path:'/lawlib2', component:resolve=>(require(["@/components/functions/lawlib2.vue"],resolve)), name:'lawlib2' },  
//   {path:'/law/:id', component:resolve=>(require(["@/components/functions/lawlib_detail.vue"],resolve)), name:'lawlib_detail' },   //article,drafts
//   {path:'/lawlib_detail', component:resolve=>(require(["@/components/functions/lawlib_detail.vue"],resolve)), name:'lawlib_detail' },  
  {path:'/lawlib_causedetail', component:resolve=>(require(["@/components/functions/cause.vue"],resolve)), name:'cause' },  
   {path:'/crim_sand', component:resolve=>(require(["@/components/functions/crim_sand.vue"],resolve)), name:'crim_sand' },   
   {path:'/creditloss', component:resolve=>(require(["@/components/functions/creditloss.vue"],resolve)), name:'creditloss' },  
	{path:'/announce', component:resolve=>(require(["@/components/functions/announce.vue"],resolve)), name:'announce' },  

	{path:'/trialNotice', component:resolve=>(require(["@/components/functions/trialNotice.vue"],resolve)), name:'trialNotice' },  

 
 {path:'/search_tools', component: ()=>import('@/components/toolsbox/search.vue') ,name:"search_tools" },
  {path:'/contracts', component: ()=>import('@/components/toolsbox/contracts/contracts.vue') ,name:"contracts" },

 {path:'/columns', component: ()=>import('@/components/toolsbox/expert/expert.vue') ,name:"columns" },
// {path:'/column/draft/:id', component: ()=>import('@/components/toolsbox/expert/draft.vue') , name:'column_draft'},
 
 
// {path:'/column/draft/:id', component: ()=>import('@/components/toolsbox/community/draftarticle.vue') , name:'column_draft'},

{path:'/:mode/draft/:id', component: ()=>import('@/components/toolsbox/community/draftarticle.vue') , name:'new_draft'}, 

 {path:'/mycolumn', component: ()=>import('@/components/toolsbox/expert/mycolumn.vue') ,name:"mycolumn" },
 {path:'/columns/:id', component: ()=>import('@/components/toolsbox/expert/column.vue') ,name:"column" },

  {path:'/column/newmember/:id/:code', component: ()=>import('@/components/toolsbox/expert/newmember.vue') ,name:"newmember" },

 {path:'/legalpaper', component: ()=>import('@/components/toolsbox/legalpaper/legalpaper.vue') ,name:"legalpaper" },

	{path:'/contracts/:id?', component: ()=>import('@/components/toolsbox/contracts/contract.vue') ,name:"contract" },
	{path:'/contract_test', component: ()=>import('@/components/toolsbox/contracts/test.vue') ,name:"contract_test" },	

//   {path:'/wenshu', component: ()=>import('@/components/functions/wenshu.vue') ,name:"wenshu" },
 
//   {path:'/wenshu_detail', component: ()=>import('@/components/toolsbox/wenshu/wenshu_detail.vue') , name:'wenshu_detail' },   //article,drafts

//   {path:'/lawlib', component: ()=>import('@/components/functions/lawlib.vue') ,name:"lawlib" },
//  {path:'/lawlib_detail', component: ()=>import('@/components/functions/lawlib_detail.vue') , name:'lawlib_detail' }, 

//   {path:'/cause', component: ()=>import('@/components/functions/cause.vue') ,name:"cause" },
//   {path:'/crim_sand', component: ()=>import('@/components/functions/crim_sand.vue') ,name:"crim_sand" },
//   {path:'/creditloss', component: ()=>import('@/components/functions/creditloss.vue') ,name:"creditloss" },
//   {path:'/announce', component: ()=>import('@/components/functions/announce.vue') ,name:"announce" },
	// component:resolve=>(require(["@/components/functions/lawlib_detail.vue"],resolve)),

  {
	path:'/community', 
	// component: ()=>import('@/components/toolsbox/community/community.vue') ,
	component:resolve=>(require(["@/components/toolsbox/community/community.vue"],resolve)),
	name:"community" ,
	//   meta:{keepAlive:true,isBack: false,}
	// children: [
	// 	{
	// 		path: 'article/:id',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
	// 		name: 'article_detail',
	// 		component: ()=>import('@/components/functions/crim_sand.vue')   
	// 	}, 

	// ]
  },	
  
  { path:'/staff/mybench', component: ()=>import('@/components/toolsbox/manager/staff.vue'), name:"staff" },
  {path:'/community/draft/:id', component: ()=>import('@/components/toolsbox/community/draftarticle.vue') , name:'my_draft'},

    {path:'/editlaw/:id', component: ()=>import('@/components/toolsbox/laws/draftlaw.vue') , name:'law_draft'}, 

//   {path:'/community/draft/:id', component: ()=>import('@/components/toolsbox/community/draftarticle.vue') , name:'my_draft'},
//   {path:'/community/:mode/:id', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'article_detail' },   //article,drafts
  
 {path:'/community/:id', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'article_detail' },   //article,drafts
  
  
//  {path:'/column/:id', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'article_detail' },   //article,drafts
  

  {path:'/:po/p/:id', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'a_detail' },

  {path:'/article', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'article' },   //article,drafts

	{path:'/letters', component: ()=>import('@/components/toolsbox/letters/letters.vue') , name:'letters' },   //article,drafts
	
	{path:'/admin', component: ()=>import('@/components/admin/admin.vue') , name:'admin' },   //article,drafts
	{path:'/dashboard', component: ()=>import('@/components/admin/dashboard.vue') , name:'dashboard' },   //article,drafts
	{path:'/contract_admin', component: ()=>import('@/components/admin/contract_admin.vue') , name:'contract_admin' },   //article,drafts
 
 	{path:'/visual', component: ()=>import('@/components/toolsbox/visual/visual.vue') , name:'visual' },   //article,drafts
	

  {path:'/article_template', component: ()=>import('@/components/toolsbox/community/article_template.vue') , name:'article_template' },   //article,drafts

  {path:'/regis_phone', component: ()=>import('@/components/info/regis_phone.vue') , name:'regis_phone' },   //article,drafts



//   {path:'/community/drafts/:id', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'article_detail' },   //article,drafts
	//   {path:'/community/drafts/:id', component: ()=>import('@/components/toolsbox/community/article.vue') , name:'article_detail' },
  
 {
	path:'/service', 
	component: ()=>import('@/components/toolsbox/service/service.vue') ,
	name:"service" ,
	//  meta:{keepAlive:true,isBack: false,}
	// children: [
	// 	{
	// 		path: 'article/:id',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
	// 		name: 'article_detail',
	// 		component: ()=>import('@/components/functions/crim_sand.vue')   
	// 	}, 

	// ]
  },

 
	{
        name:'oa_workbench',
        path:'/work/workbench',
        component: ()=>import('@/components/oa/workbench.vue')
	}, 

	// {
	// 	name:'oa_work',
	// 	path:'/work/oa',
	// 	component: ()=>import('@/components/oa/oabench.vue')
	// }, 

	{
		name:'info',
		path:'/work/info',
		component: ()=>import('@/components/oa/flows.vue')
	},

	//  , redirect:'/work/workbench' ,

	{ path:'/work', component: ()=>import('@/components/oa/manager/main.vue'), name:"oa" ,
    // children:[
	// 	{
    //     name:'oa_workbench',
    //     path:'/work/workbench',
    //     component: ()=>import('@/components/oa/workbench.vue')
	//   }, 
    //   {
    //     name:'process',
    //     path:'/work/process',
    //     component: ()=>import('@/components/oa/manager/process.vue')
	//   },
	//  {
    //     name:'newcase',
    //     path:'/work/newcase',
    //     component: ()=>import('@/components/oa/manager/newcase.vue')
	//   },
    // 	{
    //     name:'staff',
    //     path:'/work/staff',
    //     component: ()=>import('@/components/oa/manager/staff.vue')
	//   },
	//   	{
    //     name:'structure',
    //     path:'/work/structure',
    //     component: ()=>import('@/components/oa/manager/structure.vue')
	//   },
 
	//  {
    //     name:'info',
    //     path:'/work/info',
    //     component: ()=>import('@/components/oa/flows.vue')
	//   },


	//   { path:'/work/stafflist', component: ()=>import('@/components/oa/functions/stafflist.vue'), name:"stafflist" },
	  
	//   { path:'/work/admin', component: ()=>import('@/components/oa/admin.vue'), name:"admin" },
	//   { path:'/work/logs', component: ()=>import('@/components/oa/manager/logs.vue'), name:"logs" },
	//   { path:'/work/refund', component: ()=>import('@/components/oa/manager/refund.vue'), name:"refund" },
	//   { path:'/work/invoice_m', component: ()=>import('@/components/oa/manager/invoice_m.vue'), name:"invoice_m" },
	//    { path:'/work/business', component: ()=>import('@/components/oa/manager/business.vue'), name:"business" },
 	// 	{ path:'/work/inform', component: ()=>import('@/components/oa/manager/inform.vue'), name:"inform" },


	//   { path:'/work/seal', component: ()=>import('@/components/oa/manager/seal.vue'), name:"seal" },
	//   { path:'/work/fee', component: ()=>import('@/components/oa/manager/fee.vue'), name:"fee" },
	//   { path:'/work/case', component: ()=>import('@/components/oa/manager/case.vue'), name:"case" },
	//   { path:'/work/mycase', component: ()=>import('@/components/oa/manager/mycase.vue'), name:"mycase" },
	//    { path:'/work/group', component: ()=>import('@/components/oa/manager/group.vue'), name:"group" },
	//   { path:'/work/client', component: ()=>import('@/components/oa/manager/client.vue'), name:"client" },

    // ]
  },








] 

const router = new VueRouter({
  routes,
  mode:'history',
//   base:'/' 
})



//++++++++++++++++++++++++++++++++++++++++++

// import OftenUse from '@/components/OftenUse.vue'
 

// import avatar from './components/Avatar.vue'
// import miniProgm from './components/miniProgram.vue'
// import LoginBox from './components/LoginBox.vue'
// import LeftStatus from './components/LeftStatus.vue'

// import BreadCrumb from '@/components/BreadCrumb.vue'
import Header from '@/components/header.vue'
// import FunctionList from '@/components/FunctionList.vue'
import VueRouter from 'vue-router' 

import consult from '@/components/ads/consult.vue'


import OA from '@/components/oa/workbench.vue'

// function timestampToTime(timestamp) {
//   var date = new Date(timestamp );//时间戳为10位需*1000，时间戳为13位的话不需乘1000
//   var Y = date.getFullYear() + '-';
//   var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
//   var D = date.getDate() + ' ';

 
//   let hour = date.getHours()  ,min = date.getMinutes(), sec = date.getSeconds()
//   var h = hour < 10 ? '\n 0' + hour + ':' :'\n' + hour+':'  ;
//   var m = min < 10 ? '0' + min + ':' : min + ':';
//   var s = sec < 10 ? '0' + sec + ':' : sec ;
//   return Y + M + D + h + m + s;
// }


function clearAllCookie() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if(keys) {
        for(var i = keys.length; i--;)
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
}


export default {
  name: 'app',

  router,

   data() {
		return {
			pageId:'home',
			screenWidth:window.innerWidth,
			screenHeight:window.innerHeight,
            isphone:false,
            islogin:false,
			loginInfo:{"isLogin":false ,"nickName":'' },
			
			//聊天消息通知
			msgDialogVisible:false,
			msgList: ['编号', '头像', '微信昵称', '最后留言时间', '操作',], // '最后留言内容',
			msgData:[],
			msgPageLimit:false,
			msgPage:1,

			//系统消息通知
			noticeDialogVisible:false,
			noticeData:[],
			noticePageLimit:false,
			noticePage:1,
			myCoins:'0',
			header_onshow:true,

			notice_num:0,
			notice:[],
			notice_arr:[],

			// mode_type:''

   
		}
	},
	created(){
		this.getPublicInfo()
		// https://www.lawtip.cn/PHPserver/login/lawtip_CheckLoginStatus.php
		// ../PHPserver/login/lawtip_CheckLoginStatus.php  业务场景
		//https://www.lawtip.cn/PHPserver/login/test_lawtip_CheckLoginStatus.php
		this.header_onshow=true
		var that=this
		var timestamp=new Date().getTime();
		// this.axios.get( this.$root.rootUrl+'assist_check_login_status',{ // 'https://www.lawtip.cn/PHPserver/login/lawtip_CheckLoginStatus.php',{
		this.axios.get( this.$root.rootUrl+'app_check_login',{ // 'https://www.lawtip.cn/PHPserver/login/lawtip_CheckLoginStatus.php',{
        params: {
            timestamp:timestamp
		},
		// headers: {
        //     'Access-Control-Allow-Origin': "*"
        // }
        }).then(function (res) { 
            if(res.status==200){
                // window.console.log(res.data)
                let result=res.data
                if(result.status=='ok'){
                    that.$root.userInfo=result.userInfo;
                    that.$root.accountInfo=result.accountInfo;
					that.$root.islogin=true;				

					that.$store.commit('ChangeLoginStatus',true)
					that.$store.commit('getUserInfo',result.userInfo)
					that.$store.commit('ChangeAccountInfo',result.accountInfo)

					that.islogin=true
					that.loginInfo=result.userInfo
					that.loginInfo.isLogin=true
					// window.console.log( that.$root.userInfo)

					sessionStorage.setItem("isLogin", true);
					var objString = JSON.stringify(result.userInfo);
					sessionStorage.setItem("userInfo", objString);
					objString = JSON.stringify(result.accountInfo);
					sessionStorage.setItem("accountInfo", objString);

					that.myCoins=result.accountInfo.coins+''
					that.$root.accountInfo.coins=result.accountInfo.coins

					// that.refresh_coins(result.userInfo.userId)  //这个应该是多余的

					that.getNotice()

					if(result.userInfo.newUser){
						let timestamp_new= Date.parse(new Date())/1000
						if(timestamp_new-result.userInfo.newUser<3){
							// that.$message({
							// 	type: 'success',
							// 	message:'感谢新用户的使用，赠送您5法币，可用于各项付费功能~',
							// 	showClose: true,
							// 	duration:5000,
							// });

							that.$notify({
								title: '提示',
								message: '感谢新用户的使用，赠送您5法币，可用于各项付费功能',
								duration: 9000
							});
						}
					}



				}else{
					that.$root.islogin=false;
					that.$store.commit('ChangeLoginStatus',false)
				 
					sessionStorage.setItem("isLogin", false);

					localStorage.clear()

					// // 原声js是无法直接删除cookie的，当cookie的时间过期后浏览器会自动删除cookie。
					// var cookieKeys = document.cookie.match(/[^ =;]+(?=\=)/g); // 获取cookie
					// var date=new Date(); // 获取当前时间
					// date.setTime(date.getTime()-10000); // 改变当前时间
				 	// if (cookieKeys) {
					// 						// 循环设置cookie过期时间
					// 	for (var i = 0;i < cookieKeys.length; i++) {
					// 		document.cookie=cookieKeys[i]+"=0; expires="+date.toGMTString()+"; path=/";
					// 	};
					
				 
					// }
				
				 
				}
				// else if(result.status=='fail'){
				// 	that.$root.islogin=false;
				// 	that.$store.commit('ChangeLoginStatus',false)
				// 	sessionStorage.setItem("isLogin", false);

					
				// }else if(result.status=='badgate'){
				// 	that.$root.islogin=false;
				// 	that.$store.commit('ChangeLoginStatus',false)
				// 	sessionStorage.setItem("isLogin", false);
				// }        
            }

        }).catch(function (error) {
            window.console.log(error);
        });
		

		
        // window.console.log('a:',this.$root.islogin)
        // this.$root.islogin='
        // window.console.log('a:',this.$root.islogin)

		

		


		// this.isphone=isphone()
		// window.console.log('this.isphone:',this.isphone)
		// window.console.log('this.screenHeight:',this.screenHeight)
	},
	mounted() {
		// document.dispatchEvent(new Event('render-event'))
		this.isphone=isphone()
		this.screenHeight=document.body.clientHeight
		this.screenWidth=document.body.clientWidth
		

		// console.log("this.$root.myColumnSub:",this.$root.myColumnSub)

		if (window.self !== window.top) {
			// 如果网页被嵌套在 <iframe> 中
			console.log("This page is being displayed inside an iframe.");
			this.header_onshow=false
		} else {
			// 如果网页在顶层窗口中加载
			console.log("This page is not being displayed inside an iframe.");
		}
	
	
		if(!this.$root.myColumnSub){
			this.getMySub()
		}


		 

		// docElement.style.fontSize = 20 * (docElement.clientWidth / 320) + 'px' 
		// var timestamp=new Date().getTime();
		// this.axios.get('/webservice/login/VisitCount.php',{
        // params: {
        //     timestamp:timestamp
        // }
        // });

	},
  components: { 
    // HelloWorld,
	
	// OftenUse,
	// FootSearch,
	// Pages,

	// avatar,
	// miniProgm,
	// LoginBox,
	// LeftStatus,
	
	// BreadCrumb,
	Header,OA
	// FunctionList
  },
    methods: {
		ChangeType(data){
			// window.console.log('data(type):',data)

			// if(data==71){
			// 	this.$router.push({path:'/community'})
			// }else{
			// 	this.pageId=data
			// }
			if(data=='refresh_login'){
				this.loginInfo=this.$root.userInfo
				this.loginInfo.isLogin=true
			}else if(data=='header_onshow_on'){
				this.header_onshow=true
			}else if(data=='header_onshow_off'){
 
				this.header_onshow=false
			}
			// else if(data=='change2oa'){
 
			// 	this.pageId='oa'
			// }else if(data=='change2home'){
			// 	this.pageId='home'
			// }


			// pageId
			
			// else if(data==81){
			// 	this.$router.push({path:'/sound2txt'})
			// }
			// if(data!=71){
			// 	this.pageId=data
			// }else {
			// 	this.$router.push({path:'/community'})
			// } 
		},
		getMySub(){
            var that=this 
            var data= { 
 
                whattodo: "getMySubColumn_all"
            }

            this.axios.post(this.$root.rootUrl+'column',data
            ).then(function (res) {

                if(res.status==200){
      
                    let result=res.data
                    if (result.status=='ok'){
					 
                        that.$root.myColumnSub=result.data
                        // console.log("that.$root.myColumnSub:",that.$root.myColumnSub)


                    } else if (result.status=='noresult'){
                       
                    }
                     


                
                }
         
            
                
            }).catch(function (error) {
                window.console.log(error);
        
            });

        },
		ChangePanel(data){
			var that=this
			window.console.log('ChangePanel data:',data)
		 
			if (data=='msg'){
				this.msgDialogVisible=true
				this.msgPage=1
                var datas= { 
					whattodo: 'getList',
					// userId: '365919148', // this.$root.userInfo.userId,
					page:1,
                }
                this.axios.post(this.$root.rootUrl+'msg',datas
                ).then(function (res) {
					window.console.log(res)
					// let respond = res.data
                    // that.saving_sig=0
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){
                            let list = result.data
							let len = list.length
							if(len<15){
								that.msgPageLimit = true
							}
							else{
								that.msgPageLimit = false
							}
							// console.log('len:',len,'that.data.pageLimit:',that.data.pageLimit)
							// let arr
							let newMsg = 0;
							for (let i = 0; i < len; i++) {
								let opo_userId
								if (list[i].members.length == 2) {
								if (that.$root.userInfo.userId == list[i].members[0]) {
									opo_userId = list[i].members[1]
								} else {
									opo_userId = list[i].members[0]
								}

								}
								list[i]['guest_id'] = opo_userId
								list[i]['nickName'] = list[i][opo_userId]['nickName']
								list[i]['lasttime'] = timestampToTime(list[i]['updateTime'])
								list[i]['avatarUrl'] = list[i][opo_userId]['avatarUrl']

								// newMsg = list[i][that.$root.userInfo.userId]['unread'] + newMsg //365919148
								newMsg = list[i]['365919148']['unread'] + newMsg //365919148


							}
							that.$root.notice.newMsg = newMsg
							// console.log('ok')
							that.msgData=list
							window.console.log('msgData:',that.msgData)
							// that.setData({
							// 	data: list,
							// 	userId: app.globalData.userId
							// })
                            

                        } else if (result.status=='fail'){
                            that.$message('删除失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });






			}
			else if(data=='notice'){

				this.noticeDialogVisible=true

				this.getNotice()



				// this.noticeDialogVisible=true
				// this.noticePage=1
                // let datas= { 
				// 	whattodo: 'getNotice',
				// 	userId: '365919148', // this.$root.userInfo.userId,
				// 	page:1,
                // }
                // this.axios.post('https://api.lawtip.cn/notice',datas
                // ).then(function (res) {
				// 	window.console.log(res)
				// 	// let respond = res.data
                //     // that.saving_sig=0
                //     if(res.status==200){
                //         let result=res.data
                //         if(result.status=='badgate'){
                //             
                //         }else if (result.status=='ok'){
                //             let list = result.data
				// 			let len = list.length
				// 			if(len<15){
				// 				that.noticePageLimit = true
				// 			}
				// 			else{
				// 				that.noticePageLimit = false
				// 			}

				// 			let newNotice = 0;
				// 			for (let i = 0; i < len; i++) {
				// 				// let opo_userId
				// 				// if (list[i].members.length == 2) {
				// 				// if (that.$root.userInfo.userId == list[i].members[0]) {
				// 				// 	opo_userId = list[i].members[1]
				// 				// } else {
				// 				// 	opo_userId = list[i].members[0]
				// 				// }

				// 				// }
				// 				// list[i]['guest_id'] = opo_userId
				// 				// list[i]['nickName'] = list[i][opo_userId]['nickName']
				// 				// list[i]['lasttime'] = timestampToTime(list[i]['updateTime'])
				// 				// list[i]['avatarUrl'] = list[i][opo_userId]['avatarUrl']

				// 				// newMsg = list[i][that.$root.userInfo.userId]['unread'] + newMsg //365919148
				// 				newNotice = list[i]['365919148']['unread'] + newNotice //365919148


				// 			}
				// 			that.$root.notice.newNotice = newNotice
				// 			// console.log('ok')
				// 			that.noticeData=list
				// 			window.console.log('noticeData:',that.noticeData)
				// 			// that.setData({
				// 			// 	data: list,
				// 			// 	userId: app.globalData.userId
				// 			// })
                            

                //         } else if (result.status=='fail'){
                //             that.$message('删除失败');
                            
                //         }


                        
                //     }

                    
                // }).catch(function (error) {
                //     window.console.log(error);
                //     // that.saving_sig=0
                // });




			}else if(data=='mine'){
				this.$router.push({path:'/mine'})
			}else if(data=='deposit'){
				this.$router.push({path:'/deposit'})
			}
		},

		ChangeNoticePage(page){
			this.notice_arr=this.notice.splice( (page-1)*15 ,15)

		},

	 

		getNotice(page=1){
			this.noticePage=1
			var that=this
			var data= {   //没有page参数返回的是最多300个结果
				// whattodo: "GetNotice",
				// page:page,

				whattodo: 'getNoticeList',
				// token: app.globalData.token,
				// userId: app.globalData.userId,
				// page:page
			}
			
			this.axios.post(this.$root.rootUrl+'msg',data
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					let result=res.data
					// console.log('result:',result)
					if(result.status=='ok'){

						that.notice=result.data
						that.notice_num=that.notice.length
						let newnum=0
						for(let p of that.notice){
							if(p.isread=='no'){
								newnum++
							}
						}
						
						let noticeInfo={}
						noticeInfo.num=that.notice_num
						noticeInfo.newnum=newnum
						
						noticeInfo.data=result.data
						that.$store.commit('SetNoticeInfo',noticeInfo)
						that.notice_arr=that.notice.splice(0,15)
						// if ( page==1&&result.data.length>0){
						// 	that.notice_num=result.count[0].totalCount
						// 	let newnum=0
							
						// 	for(let p of that.notice){
						// 		if(p.isread=='no'){
						// 			newnum++
						// 		}
						// 	}


						// 	noticeInfo.num=result.count[0].totalCount
						// 	noticeInfo.newnum=newnum
							
						// 	noticeInfo.data=result.data
						// 	that.$store.commit('SetNoticeInfo',noticeInfo)


						// }
							


					}

		
	
				}
			
			
				
			}).catch(function (error) {
				window.console.log(error);
			
			});

		},


		refresh_coins(userid) {
			var that=this
			var datas= { 
				userid: userid,
				whattodo:'getCoins',
			}
			this.axios.post(this.$root.rootUrl+'userinfo',datas
			).then(function (res) {
				window.console.log(res)
				if(res.status==200){
					var result=res.data
					window.console.log('result:',result,'result.status:',result.status)
					if(result.status=='badgate'){
						that.$message({
							message: '请先登录哦',
							type: 'warning'
						});
					}else if (result.status=='ok'){
						that.myCoins=result.coins+''
						that.$root.accountInfo.coins=result.coins

					} 
					else if (result.status=='fail'){
						that.$message('获取余额失败，请稍后再试');
						
					} 

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});


		},


		getPublicInfo(){
			let obj = require('../public/static/publicinfo/public_info.json');
			// console.log('obj:',obj)
 			this.$store.commit('SetPublicInfo',obj)

			// var that=this
			// var timestamp=new Date().getTime();
			// this.axios.get('https://11law.lawtip.cn/php/publicinfo/public_info.json',{
			// params: {
			// 	timestamp:timestamp
			// },
			// }).then(function (res) { 
			// 	if(res.status==200){
			// 		window.console.log(res.data)
			// 		let result=res.data
			// 	 	console.log('result:',result)
			// 	}

			// }).catch(function (error) {
			// 	window.console.log(error);
			// });

			 


		},

		timestampToTime(timestamp) {
			var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
			var Y = date.getFullYear() + '-';
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			var D = date.getDate() + '';
			var h = date.getHours() + ':';   //
			var m = date.getMinutes() + ':';//
			var s = date.getSeconds();//
			if (M.length==1){
				M='0' +M
			}
			if (D.length==1){
				D='0' +D
			}
			return Y + M + D +'    '+ h + m + s
		},

		ReadAllNotice(){
			var that=this
			var datas= { 
				// _id: _id,
				whattodo:'notice_allread',
			}
			this.axios.post('https://api.lawtip.cn/msg',datas
			).then(function (res) {
				window.console.log(res)
				if(res.status==200){
					var result=res.data
		
				if (result.status=='ok'){
					that.$store.commit('SubtractAllNotice')
					let notice=that.notice
					for(let p of notice){
						p.isread='yes'
					}
					that.notice=notice
				
				} 
				

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});
		},


		open_notice_detail(detail,_id,index){
			// console.log("detail:",detail)
			detail=detail.replace(/<[\w\W]+?>/g,'')
			// console.log("detail2:",detail)


			this.notice[index].isread='yes'
			this.ReadThisNotice(_id)

			this.$alert(detail, '通知', {
				confirmButtonText: '确定',
				customClass:'alert_class',
				callback: action => {
					// this.$message({
					// 	type: 'info',
					// 	message: `action: ${ action }`
					// });
				}
			});




		},
			
		ReadThisNotice(_id){
			var that=this
			var datas= { 
				_id: _id,
				whattodo:'notice_oneread',
			}
			this.axios.post('https://api.lawtip.cn/publicInfo',datas
			).then(function (res) {
				window.console.log(res)
				if(res.status==200){
					var result=res.data
		
				if (result.status=='ok'){
					that.$store.commit('SubtractOneNotice')
				
				} 
				

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});
		},















        
	}
}

</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
/* .el-header{
	height: 280px;
} */
/* .hearder{
	height: 280px;
} */

/* @import url(../static/css/cal.css); */

/* @import url(https://www.lawtip.cn/webservice/css/cal.css);

@import url(https://www.lawtip.cn/webservice/css/home.css); */

@import "assets/css/cal.css"; 
@import "assets/css/home.css"; 

/* .home{
	display: flex;
	width:100%;
	flex-direction: column;
	min-height:800px;
} */

.mainbox{
	display: flex;
	flex-direction: row;
	width:100%;
	min-height: 500px;
 
	/* background-color: #f0f0f0; */
	/* background-color: #f6f8fa!important; */
	/* min-height: 480px; */
	/* overflow-y:hidden; */
	/* height: 680px; */ 
	/* background-color: #f6f8fa!important; */
	/* border:1px solid rgb(42, 216, 129); */
}

.leftside{
	width:10%;
	height: 100%;
	/* display: flex;
	flex-direction: column;
	align-items:center;
	justify-content: center; */
	/* border-right:1px solid rgb(191, 194, 201); */
}
.rightside{
	/* height: 100%; */
	min-height:500px;
	/* width:90%; */
	width:100%;

	display: flex;
	flex-direction: column;
 
	/* align-items:center; */
	/* border:1px solid rgb(13, 126, 56); */
	margin-left: auto;
	margin-right: auto;
	/* overflow-y:hidden; */
	
}
.rightfoot{
	display: flex;
	flex-direction: row;
	height: 10%;
	border:1px solid #3ca04a;
}

.avatar_box{
	margin-left: auto;
	margin-right:auto;
	margin-top:30px;
	width:90px;
	height:100px;
	/* border:1px solid #185c9c; */
	text-align:center;
	/* justify-content: center;  */
}
.user_name{
	margin-top:5px;
	overflow: hidden;
	padding: 4px;
	
}
.el-container{
	height: 700px;
	width:1200px;
}
 .el-header {
    background-color: #ffffff;
	height: 30px;
	color: #333;
	text-align: center;
	/* line-height: 60px; */
	
  }
  .el-footer {
	background-color: #B3C0D1;
	text-align: center;
	line-height: 60px;
	color: #333;
	
	display: flex;
	flex-direction: row;
	/* align-items:center; */
   }


  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
	/* eight: 100%; */
    /* line-height: 200px; */
	/* height: 100%; */
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
	height: 100%;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

.InnerBox{
	width:100%;
	/* height: 85%; */
	/* border:1px solid #d808d8; */
	display: flex;
	flex-direction: column;
	min-height:100%;
	/* overflow-y:scroll; */
	overflow-x: hidden;
}

.beian{
	/* border:1px solid #5a96cf; */
	/* position: relative; */
	margin-top:80px;
	text-align:center;
	font-size:12px;
	display: flex;
	flex-direction: column;
 
}



.mine{
	width:150px;
	height:40px;
	display: flex;
	flex-direction: row;
	align-items:center;
	position: fixed ;
	/* border:1px solid #d808d8; */
	bottom:10px;
	right:10px;
	font-size:25px;
	opacity: 0.5;
}

.msgCenter{
	/* min-width:400px;
	min-height: 600px; */

	width:100%;
    height:360px;
	overflow-y: scroll;
	display: flex;
	flex-direction: column;
}

 
/* .scroll-x{
    white-space:nowrap;
    display:flex;
    flex-direction: column;
    font-size:0;
} */

.div-parent{
   /* display:inline-block; */
   /* background:#cceeff; */
   background:#f1f0f0;
   display: flex;
   flex-direction: row;
   justify-content: flex-start;
   /* width:1200px; */
    border:1px solid #222;

    /* white-space: normal; 
    word-wrap: break-word; */
   overflow: hidden;
}

.div-item-title{
    width:100px;
    height:40px;
    display:flex;
 
    /* flex-direction: column; */
    align-items:center;
    justify-content:center;
    font-size:14px;
    color:#222;
    /* background:#cceeff; */
    /* margin:4px; */
    margin-left:20px;
    border:1px solid #222;
    white-space: normal;
    word-wrap: break-word;
    text-overflow:ellipsis;
    /* height:70px; */
    word-break:break-all;

}


.list_detail{
    display:flex;
    flex-direction:row;
	/* width: 1050px; */
	width:100%;
	align-items:center;
    /* border:1px solid #222; */
	
  
  
}

.list_detail2{
    display:flex;
    flex-direction:row;
    background-color:  #f1eeee;
	/* width: 1050px; */
	width:100%;
	align-items:center;
    /* border:1px solid #222; */
	
  
}



.detail_n{
 
    flex-shrink: 0;
    /* width:160px; */
    width:150px;
    /* height:100px; */

    display:flex;
    /* flex-direction: column; */

    align-items:center;
    justify-content:center;
    font-size:18px;
    /* line-height: 50px; */
    height:50px;
    color:#222;
    /* margin-left:30px; */
    margin-left:20px;
    /* border:1px solid #222; */
    white-space: normal;
    word-wrap: break-word;
    text-overflow:ellipsis;
    word-break:break-all;

}
.detail_n img{
  width:40px;
  height: 40px;
  border-radius: 15px;
}
.detail_n  el-button{
  width:112px;
  height: 22px;
  margin:auto;
  font-size:16px;
  line-height: 22px;
} 
.noticeRow{
	flex-shrink: 0;
	min-height: 50px;
	font-size:18px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	white-space: normal;
    word-wrap: break-word;
    text-overflow:ellipsis;
    word-break:break-all;

}



._tip{
	height:35px;
	line-height:35px;
	width:100%;
	padding:3px;
	border-bottom:1px solid  #dad9d9;
	font-size:14px;
}

.alert_class{
	/* border:3px solid  #c22121; */
	height: auto;
	word-break:break-all;
}

 .noticeRow{
        flex-shrink: 0;
        min-height: 50px;
        font-size:18px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        white-space: normal;
        word-wrap: break-word;
        text-overflow:ellipsis;
        word-break:break-all;

        flex-direction: row;
    	flex-wrap: wrap;

    }

    .noticeRow2{
        flex-shrink: 0;
        min-height: 50px;
        font-size:18px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        white-space: normal;
        word-wrap: break-word;
        text-overflow:ellipsis;
        word-break:break-all;
        color:#b9b9b9;

        flex-direction: row;
    	flex-wrap: wrap;
    }
</style>
